import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';
import { ServerSidePaginationList } from '../../hoc/ServerSidePaginationList.jsx';

import { deleteAphorism, getAphorisms } from '../../actions/aphorisms';
import AphorismsItem from './AphorismsItem.jsx';
import AphorismsForm from './AphorismsForm.jsx';


function Aphorisms(props) {
  let items = [];
  if (!props.isLoading){
    if (props.list.length === 0) return <AphorismsForm/>;
    else items = props.list.map(item => <AphorismsItem key={ item.id } { ...item } onDelete={ props.deleteAphorism }/>);
  }

  return <div>{ items }</div>
}

let mapStateToProps = (state) => {
  return {
    count: state.aphorisms.count,
    list: state.aphorisms.list,
  }
};

export default compose(
  connect(mapStateToProps, { loadListFromServer: getAphorisms, deleteAphorism }),
  LoginRequired,
  Page,
  ServerSidePaginationList // добавляет пагинацию со стороны сервера
)(Aphorisms);
